import {Controller} from "stimulus";
import * as Credential from "../credential";
import {PublicKeyCredentialRequestOptionsJSON} from "@github/webauthn-json/dist/types/basic/json";

export default class CredentialAuthenticatorController extends Controller {
  static values = {
    options: Object,
    callbackUrl: String,
  };

  declare optionsValue: PublicKeyCredentialRequestOptionsJSON;
  declare callbackUrlValue: string;

  connect() {
    Credential.get(this.callbackUrlValue, this.optionsValue);
  }
}
